import cn from 'client/utils/cn';

import React, { Component } from 'react';

import './index.css';

const b = cn('wide-stripe');

interface Props {
    children: React.ReactElement | React.ReactElement[];
    background?: 'gradient' | 'blue';
    isBanner?: boolean;
}

export default class WideStripe extends Component<Props> {
    render() {
        const { children, background = 'blue', isBanner = false } = this.props;

        return (
            <div className={b('', { background, banner: isBanner })}>
                <div className={b('inner')}>
                    {children}
                </div>
            </div>
        );
    }
}
